/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./time-log-get-list-action-body').TimeLogGetListActionBody} TimeLogGetListActionBody
 */

/**
 * @typedef {import('./time-log-get-list-action-response').TimeLogGetListActionResponse} TimeLogGetListActionResponse
 */

/**
 * The path of the TimeLogGetListAction action.
 */
export const timeLogGetListActionPath = new SweetPath('/api/time_log/time_log', { path: '{param}' });

/**
 * Creates a contextualized TimeLogGetListAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createTimeLogGetListAction(axios) {
  /**
   * The timeLogGetListAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,query: {limit?: number; offset?: number; filter?: Object<string,string|number|boolean>;, sort?: {by: string; order: string;}} } }
   *
   * @returns {Promise<TimeLogGetListActionResponse>}
   */
  function timeLogGetListAction({ headers = {}, parameters = {}, query = {} } = {}) {
    const path = timeLogGetListActionPath.insert(parameters);

    return axios.get(path, { params: query, headers });
  }

  return timeLogGetListAction;
}
